import React, { useState } from 'react'
import PageTitle from '../../components/PageTitle'
import { useParams } from 'react-router-dom';

const VerificationSearch = () => {
    const { slug } = useParams();
    const [value, setValue] = useState("");
    const [cardNo, setCardNo] = useState("");
    const [certificateNo, setCertificateNo] = useState("");

    const handelValue=()=>{
        if(slug==="search-id"){
            setCardNo(value);
            setValue("");
        }
        else if(slug==="search-equipment"){
            setCertificateNo(value);
            setValue("");
        }
    }
  return (
    <>
      <PageTitle title="Search" />
      <section className="contact-details pt-120 pb-120">
        <div className="container">
          <div>
            <div className="row g-5">
              <div className="col-lg-12 content-column">
                <div className="inner-column">
                  <form>
                    <div className="type-feild">
                      <i className="fa-light fa-file-certificate" />
                      <input
                        name="form_name"
                        className="required"
                        type="text"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        placeholder={`${
                          slug === "search-id"
                            ? "Enter Card No."
                            : slug === "search-equipment"
                              ? "Enter Certificate No."
                              : "Enter Certificate No."
                        }`}
                      />
                    </div>
                    <button
                      className="btn-two"
                      type="button"
                      onClick={handelValue}
                    >
                      <i className="fa-light fa-search" /> Search
                    </button>
                  </form>
                </div>
              </div>
            </div>
            {slug === "search-id" && cardNo === "2080" && (
              <>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="container my-5">
                      <div className="card shadow border-0 rounded-4 overflow-hidden">
                        <div
                          className="card-header text-center text-white py-3"
                          style={{ background: "#173763" }}
                        >
                          <h3
                            className="mb-0 fw-bold text-uppercase"
                            style={{ letterSpacing: "3px", color: "#fff" }}
                          >
                            Card Details
                          </h3>
                        </div>

                        <div className="card-body p-0">
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped mb-0 align-middle">
                              <tbody>
                                <tr>
                                  <th
                                    className="bg-light px-4 py-3"
                                    style={{ width: "40%" }}
                                  >
                                    Card No
                                  </th>
                                  <td className="px-4 py-3">2080</td>
                                </tr>

                                <tr>
                                  <th className="bg-light px-4 py-3">
                                    Iqama No
                                  </th>
                                  <td className="px-4 py-3">2552701886</td>
                                </tr>

                                <tr>
                                  <th className="bg-light px-4 py-3">
                                    Operator Name
                                  </th>
                                  <td className="px-4 py-3">
                                    HOMER EATADILLA LLAMERA
                                  </td>
                                </tr>

                                <tr>
                                  <th className="bg-light px-4 py-3">
                                    Company Name
                                  </th>
                                  <td className="px-4 py-3">
                                    MODERN MEDIA SYSTEM COMPANY
                                  </td>
                                </tr>

                                <tr>
                                  <th className="bg-light px-4 py-3">
                                    Issue Date
                                  </th>
                                  <td className="px-4 py-3">03/02/2026</td>
                                </tr>

                                <tr>
                                  <th className="bg-light px-4 py-3">
                                    Expiry Date
                                  </th>
                                  <td className="px-4 py-3">02/02/2027</td>
                                </tr>

                                <tr>
                                  <th className="bg-light px-4 py-3">
                                    Remaining Period
                                  </th>
                                  <td className="px-4 py-3">
                                    8 months, 22 days
                                  </td>
                                </tr>

                                <tr>
                                  <th className="bg-light px-4 py-3">Trade</th>
                                  <td className="px-4 py-3">RIGGER LEVEL 2</td>
                                </tr>

                                <tr>
                                  <th className="bg-light px-4 py-3">Status</th>
                                  <td className="px-4 py-3">
                                    <span className="text-success fw-bold">
                                      Valid{" "}
                                      <i className="fa fa-check-circle ms-1"></i>
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {slug === "search-equipment" && certificateNo === "KIC5232" && (
              <div className="row">
                <div className="col-lg-12">
                  <div className="container my-5">
                    <div className="card shadow border-0 rounded-4 overflow-hidden">
                      <div
                        className="card-header text-center text-white py-3"
                        style={{ background: "#173763" }}
                      >
                        <h3
                          className="mb-0 fw-bold text-uppercase"
                          style={{ letterSpacing: "3px", color: "#fff" }}
                        >
                          Certificate Details
                        </h3>
                      </div>

                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-bordered table-striped mb-0 align-middle">
                            <tbody>
                              <tr>
                                <th
                                  className="bg-light px-4 py-3"
                                  style={{ width: "40%" }}
                                >
                                  Cert No
                                </th>
                                <td className="px-4 py-3">KIC5232</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Sticker No
                                </th>
                                <td className="px-4 py-3">5157</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Equipment Description
                                </th>
                                <td className="px-4 py-3">DIESEL GENERATOR</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Equipment Serial/ID No
                                </th>
                                <td className="px-4 py-3">N/A</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Equipment Type
                                </th>
                                <td className="px-4 py-3">N/A</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Inspection Date
                                </th>
                                <td className="px-4 py-3">14/10/2025</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Expiry Date
                                </th>
                                <td className="px-4 py-3">13 Oct 2026</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Remaining Period
                                </th>
                                <td className="px-4 py-3">5 months, 5 days</td>
                              </tr>
                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Company Name
                                </th>
                                <td className="px-4 py-3">ZAMIL COOL CARE</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">Plate No</th>
                                <td className="px-4 py-3">ZCC/DG-02</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Manufacturer
                                </th>
                                <td className="px-4 py-3">HYUNDAI</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Inspected By
                                </th>
                                <td className="px-4 py-3">NASIR MEHMOOD</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Capacity / SWL
                                </th>
                                <td className="px-4 py-3">5.5kV.A</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">Status</th>
                                <td className="px-4 py-3">
                                  <span className="text-success fw-bold">
                                    Valid{" "}
                                    <i className="fa fa-check-circle ms-1"></i>
                                  </span>
                                </td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">Remarks</th>
                                <td className="px-4 py-3">-</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-xl-12 col-lg-12 mb-5 mb-lg-0">
                <div className="sec-title mb-40">
                  <p
                    className="text wow fadeInUp"
                    data-wow-delay="200ms"
                    data-wow-duration="1500ms"
                  >
                    <span className="text-danger">Disclaimer</span> : Pak Arab
                    Inspection LTD. CO provides services based on international
                    standards and industry best practices. Pak Arab Inspection
                    LTD. CO is not responsible for incidents, damages, or
                    operational failures resulting from improper equipment use,
                    unsafe practices, inadequate maintenance, or non-compliance
                    after service completion.
                  </p>
                  <p>
                    For inquiries:
                    <br />
                    <a href="mailto:info@paic-sa.com">info@paic-sa.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default VerificationSearch